import { Box, Checkbox, TextareaAutosize, Typography, useTheme } from "@mui/material";
import PageHeader from "../../../components/PageHeader/PageHeader";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import { useFormikContext } from "formik";
import { t } from "i18next";
import PropTypes from "prop-types";

const WareHouseLoadInfo = ({ status }) => {
  const theme = useTheme();

  
  const isDisabled = status?.id !== 2 && status.id !== 6 && status.id !==5;
  const formik = useFormikContext();

  return (
    <>
      <PageHeader title={t("warehouseInformation").toLocaleUpperCase()} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, margin: { xs: '24px 0', md: '64px 49px' },  p: { xs: 2, md: 3 } }}>
        <Box sx={{ width: { xs: '100%', md: '25%' } }}>
          <CustomDatePicker
            label={"Arrival Date"}
            name="arrivalDate"
            disableFuture={true}
            disabled={isDisabled}
          />
        </Box>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          {[
            { name: "title", label: "Title" },
            { name: "key", label: "Key" },
            { name: "partsWithCar", label: "Parts with Car" },
            { name: "removeEngine", label: "Remove Engine" },
            { name: "hasCatalyst", label: "Has Catalyst" },
          ].map((item) => (
            <Box
              key={item.name}
              sx={{ display: "flex", alignItems: "center", minWidth: 150, bgcolor: theme.palette.background.default, borderRadius: 2, px: 2, py: 1, boxShadow: '0 1px 4px 0 rgba(11, 60, 93, 0.06)' }}
            >
              <Checkbox
                disabled={isDisabled}
                onChange={formik.handleChange}
                checked={formik.values?.[item.name] || false}
                name={item.name}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: theme.palette.secondary.main } }}
              />
              <Typography sx={{  fontWeight: 700 }}>{item.label}</Typography>
            </Box>
          ))}
        </Box>
        <TextareaAutosize
          disabled={isDisabled}
          name="arrivalNote"
          style={{
            minHeight: "90px",
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: "8px",
            padding: "10px",
            resize: "none",
            fontFamily: "inherit",
            fontSize: 15,
            color: theme.palette.text.primary,
          }}
          placeholder={"Arrival Note (optional)"}
          value={formik.values.arrivalNote || ""}
          onChange={formik.handleChange}
        />
      </Box>
    </>
  );
};

WareHouseLoadInfo.propTypes = {
  status: PropTypes.object.isRequired,
};

export default WareHouseLoadInfo;
